import api from './api';

class ProjectScheduleService {
    // Get all project schedules
    static async getAll(page = 1, limit = 20, filters = {}) {
        try {
            const params = new URLSearchParams({
                page: page.toString(),
                limit: limit.toString(),
                ...filters
            });
            const response = await api.get(`/project-schedules?${params}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    // Get project schedule by ID
    static async getById(id) {
        try {
            const response = await api.get(`/project-schedules/${id}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    // Get project schedules by project ID
    static async getByProjectId(projectId) {
        try {
            const response = await api.get(`/project-schedules/project/${projectId}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    // Create new project schedule
    static async create(data) {
        try {
            const response = await api.post('/project-schedules', data);
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    // Create multiple project schedules (bulk)
    static async createBulk(schedules) {
        try {
            const response = await api.post('/project-schedules/bulk', { schedules });
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    // Update project schedule
    static async update(id, data) {
        try {
            const response = await api.put(`/project-schedules/${id}`, data);
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    // Update project schedule status
    static async updateStatus(id, status) {
        try {
            const response = await api.patch(`/project-schedules/${id}/status`, { status });
            return response.data;
        } catch (error) {
            throw error;
        }
    }
}

export default ProjectScheduleService;